(() => {
  const parseNumber = (value, fallback = 0) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };
  const randomBetween = (min, max) => {
    const safeMin = Math.min(min, max);
    const safeMax = Math.max(min, max);
    return Math.floor(Math.random() * (safeMax - safeMin + 1)) + safeMin;
  };
  const hydrateUrgencyBanner = (banner) => {
    if (!banner || banner.dataset.bnHydrated === 'true') return;
    banner.dataset.bnHydrated = 'true';
    const valueNode = banner.querySelector('[data-bn-urgency-value]');
    if (!valueNode) return;
    const storageKey = banner.dataset.storageKey || `bnUrgency:${banner.id || 'default'}`;
    const baseValue = parseNumber(banner.dataset.initialNumber, 0);
    const intervalMs = parseNumber(banner.dataset.updateIntervalMs, 300000);
    const firstMin = parseNumber(banner.dataset.firstMin, 150);
    const firstMax = parseNumber(banner.dataset.firstMax, 220);
    const warmMin = parseNumber(banner.dataset.warmMin, 280);
    const warmMax = parseNumber(banner.dataset.warmMax, 420);
    const hotMin = parseNumber(banner.dataset.hotMin, 400);
    const hotMax = parseNumber(banner.dataset.hotMax, 520);
    let firstPaint = true;
    const loadSnapshot = () => {
      try {
        const raw = window.localStorage.getItem(storageKey);
        if (!raw) return { value: baseValue, lastUpdate: Date.now() };
        const data = JSON.parse(raw);
        if (!data || typeof data.value !== 'number' || typeof data.lastUpdate !== 'number') {
          return { value: baseValue, lastUpdate: Date.now() };
        }
        return data;
      } catch (error) {
        return { value: baseValue, lastUpdate: Date.now() };
      }
    };
    const saveSnapshot = (snapshot) => {
      try { window.localStorage.setItem(storageKey, JSON.stringify(snapshot)); } catch (error) {}
    };
    const update = () => {
      const now = Date.now();
      const snapshot = loadSnapshot();
      const elapsed = now - snapshot.lastUpdate;
      if (firstPaint) {
        snapshot.value += elapsed < intervalMs ? randomBetween(warmMin, warmMax) : randomBetween(firstMin, firstMax);
        firstPaint = false;
      } else if (elapsed >= intervalMs && !document.hidden) {
        snapshot.value += randomBetween(hotMin, hotMax);
      }
      snapshot.lastUpdate = now;
      valueNode.textContent = snapshot.value.toLocaleString('es-CL');
      saveSnapshot(snapshot);
    };
    update();
    window.setInterval(update, 60000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  };
  const hydrateWhatsApp = (node) => {
    if (!node || node.dataset.bnHydrated === 'true') return;
    node.dataset.bnHydrated = 'true';
    const link = node.querySelector('.bn-floating-whatsapp__link');
    if (!link || node.dataset.enablePulse !== 'true') return;
    window.addEventListener('load', () => {
      window.setTimeout(() => link.classList.add('is-pulse'), 2400);
    }, { once: true });
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bn-urgency-banner]').forEach(hydrateUrgencyBanner);
    scope.querySelectorAll('[data-bn-whatsapp]').forEach(hydrateWhatsApp);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
